import { h } from "preact";

import IconProps from "./IconProps";

enum Variant {
    Dot = "dot",
    Default = "default"
}

const DEFAULT_COLOR = "var(--label-primary)";

function IconPending({
    class: cssClass,
    variant = Variant.Default,
    color
}: IconProps & { variant?: Variant; }) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    if (variant === Variant.Default) {
        return (
            <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#l5m807tkna)">
                    <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M1 6a5 5 0 1 1 10 0A5 5 0 0 1 1 6zm5-6a6 6 0 1 0 0 12A6 6 0 0 0 6 0zm.5 3.75a.5.5 0 0 0-1 0v2.4a.6.6 0 0 0 .6.6h2.4a.5.5 0 0 0 0-1h-2v-2z"/>
                </g>
                <defs>
                    <clipPath id="l5m807tkna">
                        <path fill="#fff" d="M0 0h12v12H0z"/>
                    </clipPath>
                </defs>
            </svg>
        );
    }

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#1tn6rcyh8a)">
                <path fill={fill} fill-rule="evenodd" clip-rule="evenodd"
                    d="M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0zm.75 3.75a.75.75 0 1 0-1.5 0v2.438c0 .414.336.75.75.75h2.438a.75.75 0 1 0 0-1.5H6.75V3.75z"/>
            </g>
            <defs>
                <clipPath id="1tn6rcyh8a">
                    <path fill="#fff" d="M0 0h12v12H0z"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export default IconPending;
export { Variant as IconPendingVariant };
